import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Form } from 'common/components';
import { createRoute } from 'lib/util';

class SendTokenAsign extends PureComponent {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
    subcompanyId: PropTypes.string.isRequired,
    assetId: PropTypes.string.isRequired,
    handleSendTokenAsign: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    t: PropTypes.func.isRequired,
  };

  render = () => {
    return (
      <Form.Button
        text={this.props.t('actions.sendTokenAsign')}
        color={'outline-info'}
        extraClassName={'btn-sm my-1'}
        isLoading={this.props.isLoading}
        onClick={(e) => {
          e.preventDefault();
          this.props.handleSendTokenAsign(this.props.asset);
        }}
      />
    );
  };
}

export default translate()(SendTokenAsign);



// WEBPACK FOOTER //
// src/components/assets/actions/AssetsSendTokenAsign.js